import { render, staticRenderFns } from "./ManagementRFIDTags.vue?vue&type=template&id=7b749dfe&scoped=true&"
import script from "./ManagementRFIDTags.vue?vue&type=script&lang=ts&"
export * from "./ManagementRFIDTags.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b749dfe",
  null
  
)

export default component.exports